import React, { useState } from "react";
import { toast } from "sonner";
import { submitSpeaking, extractErrorMessage } from "@/lib/api";
import { SPEAKING_FORM } from "@/constants/testIds";
import Reveal from "../sections/Reveal";

const FORMATS = [
  { value: "keynote", label: "Keynote" },
  { value: "panel", label: "Panel" },
  { value: "workshop", label: "Workshop" },
  { value: "fireside", label: "Fireside" },
];

export default function SpeakingForm() {
  const [form, setForm] = useState({
    name: "",
    organization: "",
    event_name_date: "",
    event_format: "keynote",
    email: "",
  });
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");
    try {
      await submitSpeaking(form);
      setStatus("success");
      toast.success("Speaking inquiry received.");
      setForm({
        name: "",
        organization: "",
        event_name_date: "",
        event_format: form.event_format,
        email: "",
      });
    } catch (err) {
      setStatus("error");
      const msg = extractErrorMessage(err);
      setErrorMsg(msg);
      toast.error(msg);
    }
  };

  return (
    <form
      data-testid={SPEAKING_FORM.root}
      onSubmit={onSubmit}
      noValidate
      className="flex flex-col gap-6"
    >
      <Reveal>
        <div>
          <label htmlFor="sp-name" className="rk-label">Name</label>
          <input id="sp-name" type="text" required
            data-testid={SPEAKING_FORM.nameInput}
            value={form.name}
            onChange={update("name")}
            className="rk-field"
            placeholder="Your full name"
          />
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <div>
          <label htmlFor="sp-org" className="rk-label">Organization</label>
          <input id="sp-org" type="text" required
            data-testid={SPEAKING_FORM.orgInput}
            value={form.organization}
            onChange={update("organization")}
            className="rk-field"
            placeholder="Hosting organization"
          />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div>
          <label htmlFor="sp-event" className="rk-label">Event name / date</label>
          <input id="sp-event" type="text" required
            data-testid={SPEAKING_FORM.eventInput}
            value={form.event_name_date}
            onChange={update("event_name_date")}
            className="rk-field"
            placeholder="e.g. AI Summit — March 12, 2026"
          />
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div>
          <label htmlFor="sp-format" className="rk-label">Event format</label>
          <select id="sp-format"
            data-testid={SPEAKING_FORM.formatSelect}
            value={form.event_format}
            onChange={update("event_format")}
            className="rk-field rk-select"
          >
            {FORMATS.map((f) => (
              <option key={f.value} value={f.value}>{f.label}</option>
            ))}
          </select>
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div>
          <label htmlFor="sp-email" className="rk-label">Email</label>
          <input id="sp-email" type="email" required
            data-testid={SPEAKING_FORM.emailInput}
            value={form.email}
            onChange={update("email")}
            className="rk-field"
            placeholder="booking@organization.com"
          />
        </div>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="flex flex-wrap items-center gap-4 pt-2">
          <button type="submit" disabled={status === "loading"}
            data-testid={SPEAKING_FORM.submit}
            className="rk-btn-primary"
          >
            {status === "loading" ? "Sending…" : "Submit Speaking Inquiry"}
          </button>
          <span className="rk-caption">Response within 3 business days.</span>
        </div>
      </Reveal>
      {status === "success" && (
        <div data-testid={SPEAKING_FORM.success}
          style={{ paddingTop: 14, borderTop: "1px solid var(--rk-copper)", fontSize: 15 }}>
          Inquiry received. Rakia will reach out directly.
        </div>
      )}
      {status === "error" && (
        <div data-testid={SPEAKING_FORM.error} style={{ color: "var(--rk-danger)", fontSize: 14 }}>
          {errorMsg}
        </div>
      )}
    </form>
  );
}
